<script setup lang="ts">
import { ref } from 'vue'

import AppMenuItem from '@/layout/AppMenuItem.vue'
import { PermissionEnum } from '@/components/authorization/model/Permissions.ts'
import { useAuthorizationStore } from '@/components/authorization/model/AuthorizationRepository.ts'

const authorizationRepository = useAuthorizationStore()
export interface MenuItemData {
  label: string
  icon?: string
  to?: string
  permission?: PermissionEnum
  items: MenuItemData[]
}

const model = ref([
  {
    label: 'Budowa ',
    items: [
      { label: 'Budowa i system', icon: 'pi pi-fw pi-cloud-upload', to: '/siteEdit', permission: PermissionEnum.SITE_DATA_VIEW },
      { label: 'Elementy konstrukcji - import', icon: 'pi pi-fw pi-cloud-upload', to: '/constructionItemsImport', permission: PermissionEnum.ITEMS_IMPORT },
      { label: 'Elementy budowy', icon: 'pi pi-fw pi-th-large', to: '/reports/siteItemsReport', permission: PermissionEnum.ITEMS_ON_SITE_REPORT }
    ]
  },
  // {
  //   label: 'Farby',
  //   items: [
  //     { label: 'Lista farb', icon: 'pi pi-fw pi-palette', to: '/paint/paintList', permission: PermissionEnum.PAINT_LIST_VIEW },
  //     { label: 'Lista zamówień farb', icon: 'pi pi-fw pi-list', to: '/paint/paintOrderList', permission: PermissionEnum.PAINT_WAREHOUSE_VIEW },
  //     { label: 'Lista dostaw farb', icon: 'pi pi-fw pi-truck', to: '/paint/paintDeliveryList', permission: PermissionEnum.PAINT_WAREHOUSE_VIEW },
  //     { label: 'Magazyn', icon: 'pi pi-fw pi-box', to: '/paint/displayPaintWarehouse', permission: PermissionEnum.PAINT_WAREHOUSE_VIEW },
  //     { label: 'Nowa dostawa', icon: 'pi pi-fw pi-plus-circle', to: '/paint/createPaintDeliveryV2', permission: PermissionEnum.PAINT_WAREHOUSE_VIEW },
  //     { label: 'Lista farb magazyn', icon: 'pi pi-fw pi-list', to: '/paint/paintWarehouseItems', permission: PermissionEnum.PAINT_WAREHOUSE_VIEW },
  //     { label: 'Wydanie farb', icon: 'pi pi-fw pi-send', to: '/paint/paintIssuance', permission: PermissionEnum.PAINT_WAREHOUSE_VIEW },
  //     { label: 'Zużycie farb', icon: 'pi pi-fw pi-check-circle', to: '/paint/paintConsumption', permission: PermissionEnum.PAINT_WAREHOUSE_VIEW }
  //   ]
  // },
  {
    label: 'Katalog',
    items: [
      { label: 'Lista elementów', icon: 'pi pi-fw pi-bars', to: '/constructionItems', permission: PermissionEnum.CATALOG_VIEW },
      { label: 'Lista farb', icon: 'pi pi-fw pi-palette', to: '/paint/paintList', permission: PermissionEnum.PAINT_LIST_VIEW }
    ]
  },
  {
    label: 'Administracja',
    items: [
      { label: 'Lista użytkowników', icon: 'pi pi-fw pi-users', to: '/userList', permission: PermissionEnum.ADMIN },
      { label: 'Lista drukarek', icon: 'pi pi-fw pi-print', to: '/printers', permission: PermissionEnum.ADMIN },
      { label: 'Lista kontrahentów', icon: 'pi pi-fw pi-book', to: '/contractors', permission: PermissionEnum.CONTRACTOR_LIST_VIEW },
      { label: 'Przydzielone do pracownika', icon: 'pi pi-fw pi-th-large', to: '/workItems/workload', permission: PermissionEnum.MANUAL_WORKFLOW_MOVEMENT }
    ]
  },
  {
    label: 'Dostawy',
    items: [
      { label: 'Lista dostaw', icon: 'pi pi-fw pi-truck', to: '/constructionDeliveryList', permission: PermissionEnum.DELIVERY_LIST_VIEW },
      { label: 'Nowa przychodząca', icon: 'pi pi-fw pi-sign-in', to: '/newIncomingDelivery', permission: PermissionEnum.INCOMING_DELIVERY_CREATE_VIEW },
      { label: 'Nowa wychodząca', icon: 'pi pi-fw pi-sign-out', to: '/newOutgoingDelivery', permission: PermissionEnum.OUTGOING_DELIVERY_CREATE_VIEW }
    ]
  },
  {
    label: 'Pomiary',
    items: [
      { label: 'Pomiary', icon: 'pi pi-fw pi-gauge', to: '/thicknessMeasurementList', permission: PermissionEnum.THICKNESS_MEASUREMENT }
    ]
  },
  {
    label: 'Zadania',
    items: [
      { label: 'Planowanie zadań', icon: 'pi pi-fw pi-calendar', to: '/workItems/groups', permission: PermissionEnum.PAINT_SHOP_MANAGER },
      { label: 'Przygotowanie powierzchni', icon: 'pi pi-fw pi-th-large', to: '/workItems/surfacePreparation', permission: PermissionEnum.SURFACE_PREPARATION_ASSIGN },
      { label: 'Podkład', icon: 'pi pi-fw pi-stop', to: '/workItems/primerPainting', permission: PermissionEnum.PRIMER_PAINTING_ASSIGN },
      { label: 'Ogień', icon: 'pi pi-fw pi-exclamation-triangle', to: '/workItems/fireProtectionPainting', permission: PermissionEnum.FIRE_PROTECTION_PAINTING_ASSIGN },
      { label: 'Międzywarstwa', icon: 'pi pi-fw pi-clone', to: '/workItems/interLayerPainting', permission: PermissionEnum.INTER_LAYER_PAINTING_ASSIGN },
      { label: 'Nawierzchnia', icon: 'pi pi-fw pi-bars', to: '/workItems/topLayerPainting', permission: PermissionEnum.TOP_COAT_PAINTING_ASSIGN },
      { label: 'Pomiary', icon: 'pi pi-fw pi-gauge', to: '/workItems/thicknessMeasurement', permission: PermissionEnum.THICKNESS_MEASUREMENT_ASSIGN }
    ]
  },
  {
    label: 'Raporty',
    items: [
      { label: 'Grubości elementów', icon: 'pi pi-fw pi-th-large', to: '/reports/thickness', permission: PermissionEnum.ITEMS_ON_SITE_REPORT },
      { label: 'Zużycia', icon: 'pi pi-fw pi-th-large', to: '/reports/usage', permission: PermissionEnum.ITEMS_ON_SITE_REPORT },
      { label: 'Zużycie farb', icon: 'pi pi-fw pi-chart-bar', to: '/reports/paintConsumption', permission: PermissionEnum.ITEMS_ON_SITE_REPORT }
    ]
  },
  {
    label: 'Wersja mobilna',
    items: [
      { label: 'Wersja mobilna', icon: 'pi pi-fw pi-mobile', to: '/mobile/workLoad', permission: PermissionEnum.WORK_LOAD_MOBILE }
    ]
  }

] as MenuItemData[])


</script>

<template>
  <ul class="layout-menu">
    <template v-for="(item, i) in model" :key="item">
      <app-menu-item :item="item" :index="i" v-if="authorizationRepository.hasPermissionForMenuItem(item)"></app-menu-item>

    </template>

    <li class="mt-3 layout-root-menuitem">
      <i class=" pi pi-fw pi-info layout-menuitem-icon mr-2"/>
      <span class="layout-menuitem-text">
          <a class="layout-menuitem-text" href="/docs/index.html" target="_blank">Dokumentacja</a>
      </span>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
a.layout-menuitem-text, a.layout-menuitem-text:hover, a.layout-menuitem-text:visited, a.layout-menuitem-text:active {
  color: inherit;
  text-decoration: none;
}

</style>
